import React from 'react';
import classNames from 'classnames';
import styles from './loader-line.module.scss';

export const LoaderLine = ({ isActive }) => (
    <div
        className={classNames(
            styles.line,
            isActive && styles.active,
            isActive && styles.animation
        )}
    />
);
